import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";

const WishlistContext = createContext(null);
export const useWishlist = () => useContext(WishlistContext);

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);

  const refresh = useCallback(() => {
    if (!user) { setIds([]); return; }
    api.get("/wishlist/ids").then((r) => setIds(r.data)).catch(() => {});
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const isWishlisted = (id) => ids.includes(id);

  const toggle = async (id) => {
    if (!user) return false;
    if (ids.includes(id)) {
      setIds((p) => p.filter((x) => x !== id));
      api.delete(`/wishlist/${id}`).catch(() => refresh());
    } else {
      setIds((p) => [...p, id]);
      api.post(`/wishlist/${id}`).catch(() => refresh());
    }
    return true;
  };

  return (
    <WishlistContext.Provider value={{ ids, isWishlisted, toggle, refresh, count: ids.length }}>
      {children}
    </WishlistContext.Provider>
  );
}
